import type { InternalAxiosRequestConfig } from 'axios';

/**
 * Заголовок языка экрана — ЕДИНСТВЕННЫЙ производитель на весь фронт.
 *
 * ЗАЧЕМ. Справочники и история в общей с v4 базе хранят подстановки `$zl[N]`, и
 * разворачивает их бэкенд. Без этого заголовка он развернёт их русским словарём, и
 * англоязычный оператор получит английский экран с русскими статусами.
 *
 * ⚠️ ПОЧЕМУ ОТДЕЛЬНЫЙ МОДУЛЬ, А НЕ ТРИ КОПИИ. Настроенных инстансов axios в боевом коде
 * **три**: `shared/api/client.ts`, `api/client.ts` (через него ходят задачи) и
 * сгенерированный `api/generated/inventory/http-client.ts`. Первая редакция цикла 97
 * поставила заголовок в ОДИН из них — и живой экран журнала задачи остался русским при
 * `lang="en"`, потому что запрос идёт через второй. Это класс «эффект производится в
 * нескольких местах, а починен в одном», уже стоивший проекту одного разбора (редирект
 * на /login, девять мест).
 *
 * ⚠️ Источник языка — `<html lang>`, который ставит `setDocumentLanguage` при каждой
 * смене. НЕ `localStorage.language`: ключ там есть только когда оператор выбрал язык САМ;
 * когда язык пришёл из настройки установки `MAINLANG`, ключа нет — и заголовок бы не ушёл.
 * НЕ i18next напрямую: клиенты создаются на импорте модуля, а статический импорт
 * `@i18n/config` оттуда роняет загрузку словарей в чужих тестах (замер цикла 96).
 */
export function applyLanguageHeader(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  try {
    const language = typeof document !== 'undefined' ? document.documentElement.lang : '';
    if (language && config.headers) {
      config.headers['Accept-Language'] = language;
    }
  } catch {
    // Заголовок не уйдёт — сервер развернёт русским, как и до цикла 97.
  }
  return config;
}
